import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';

export function transformBackendErrors(response: BackendErrorResponse): string[] {
  if (!response.errors || response.errors.length === 0) {
    return [response.message];
  }

  return Object.entries(response.errors).map(([key, value]) => {
    if (Array.isArray(value)) {
      return `${key}: ${value.join(', ')}`;
    }
    return `${key}: ${value}`;
  });
}
